import { Card, CardHeader, CardTitle, CardContent, CardDescription } from '@/components/ui/card';
import { Table, TableBody, TableCell, TableHead, TableHeader, TableRow } from '@/components/ui/table';

function formatShipBy(shipBy) {
  if (shipBy == null || shipBy === '') return '—';
  const d = new Date(shipBy);
  if (Number.isNaN(d.getTime())) return String(shipBy);
  const start = new Date();
  start.setHours(0, 0, 0, 0);
  const day = new Date(d);
  day.setHours(0, 0, 0, 0);
  const diffDays = Math.round((day - start) / 86400000);
  if (diffDays === 0) return 'Today';
  if (diffDays === -1) return 'Yesterday';
  if (diffDays < -1) return `${Math.abs(diffDays)} days ago`;
  return 'Today';
}

function formatDaysLate(v) {
  if (v === null || v === undefined || v === '') return '—';
  return String(v);
}

function formatImpact(raw) {
  if (raw == null || raw === '') return '—';
  const s = String(raw).trim();
  if (s.startsWith('+') || s.startsWith('−') || s.startsWith('-')) return s;
  return `+${s}`;
}

export function PreemptiveActionsTable({ actions = [] }) {
  return (
    <Card className="bg-card border-border/80" data-testid="preemptive-actions-table">
      <CardHeader className="pb-3">
        <CardTitle className="text-base font-semibold">Pre-Emptive Actions</CardTitle>
        <CardDescription className="text-xs">Shipping these orders today may prevent further risk score increase.</CardDescription>
      </CardHeader>
      <CardContent>
        <div className="rounded-lg border border-border/60 overflow-hidden">
          <Table>
            <TableHeader>
              <TableRow className="bg-muted/30 hover:bg-muted/30">
                <TableHead className="text-xs font-semibold">Risk Type</TableHead>
                <TableHead className="text-xs font-semibold">Order ID</TableHead>
                <TableHead className="text-xs font-semibold">Ship By</TableHead>
                <TableHead className="text-xs font-semibold">Days Late</TableHead>
                <TableHead className="text-xs font-semibold text-right">Potential Impact</TableHead>
              </TableRow>
            </TableHeader>
            <TableBody>
              {actions.length === 0 && (
                <TableRow>
                  <TableCell colSpan={5} className="text-center text-sm text-muted-foreground py-8">No pre-emptive actions required</TableCell>
                </TableRow>
              )}
              {actions.map((action, i) => (
                <TableRow key={action.id || i} className="hover:bg-muted/20">
                  <TableCell className="text-sm">{action.risk_type}</TableCell>
                  <TableCell className="text-sm font-mono text-muted-foreground">{action.order_id ?? '—'}</TableCell>
                  <TableCell className="text-sm text-muted-foreground">{formatShipBy(action.ship_by)}</TableCell>
                  <TableCell className="text-sm tabular-nums text-muted-foreground">{formatDaysLate(action.days_late)}</TableCell>
                  <TableCell className="text-sm font-medium tabular-nums text-right text-[hsl(0,84%,60%)]">{formatImpact(action.potential_impact)}</TableCell>
                </TableRow>
              ))}
            </TableBody>
          </Table>
        </div>
      </CardContent>
    </Card>
  );
}
